var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"the-app",attrs:{"id":"cp"}},[_c('v-main',{staticClass:"the-app__main"},[_c('div',{staticClass:"the-app__root",attrs:{"id":"app"}},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }